var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section" }, [
    _c("div", { staticClass: "preview-schedule" }, [
      _vm._v("\n    " + _vm._s(_vm.duration) + " HORAS DE LIMPEZA POR\n    "),
      _c("span", [_vm._v(_vm._s(_vm.price.formated))]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Produtos de limpeza, transporte e alimentação do profissional inclusos."
        )
      ])
    ]),
    _vm._v(" "),
    _vm.to_be === "schedule"
      ? _c(
          "div",
          {
            staticClass: "btn bg-pink",
            on: {
              click: function($event) {
                _vm.searchProfessionals()
                _vm.$emit("scrollTo", "#professionals")
              }
            }
          },
          [_vm._v("buscar")]
        )
      : _c(
          "div",
          {
            staticClass: "btn bg-pink",
            on: {
              click: function($event) {
                return _vm.$emit("scrollTo", "#informations")
              }
            }
          },
          [_vm._v("confirmar")]
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33e5b9b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33e5b9b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/OrdersAndSubscriptions/ConfirmPeriodPrice.vue
// module id = null
// module chunks = 